import React from 'react';
class NotFound extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)', fontSize: '50px', color: '#ccc' }} >404</div>
    )
  }
}
export default NotFound;